import React from "react"
import classes from "./MobileBreadcrumb.module.css"
import Typography from "../../../../../ui/atoms/Typography"
import Breadcrumb from "../../../../../ui/molecules/Breadcrumb"
import { BreadcrumbSegment } from "../../../../../ui/organisms/HeroBreadcrumb"

interface Props {
  breadcrumb: BreadcrumbSegment[]
  title: string
  subtitle?: React.ReactNode
  logo?: React.ReactNode
  className?: string
}

const MobileBreadcrumb = ({
  breadcrumb,
  title,
  subtitle,
  logo,
  className,
}: Props) => {
  return (
    <div className={`pb-4 bg-disabled ${className ?? ""}`}>
      {breadcrumb && (
        <div className={classes.breadcrumbContainer}>
          <Breadcrumb items={breadcrumb} />
        </div>
      )}
      <div className={classes.titleContainer}>
        {!logo && (
          <Typography variant="h5" component="h1" className={classes.title}>
            {title}
          </Typography>
        )}
        {logo}
        {subtitle}
      </div>
    </div>
  )
}

export default MobileBreadcrumb
